/**
 * DocsCorpus Resource.
 *
 * Thin 1:1 mapping to the GLOBAL docs corpus surface (/v1/docs/*): the
 * server-side, globally indexed (dense + lexical) corpus of the SDK method
 * reference + narrative guides. The corpus is system-wide (non-tenant), so
 * search/read results are NOT tenant-filtered and are identical across accounts.
 *
 * DISTINCT from `sdk.docs` (the client-bundled `DocsIndex`, unchanged) — this
 * resource reaches the server corpus that backs the Shogun assistant's
 * docs_search / docs_read tools.
 */

import type { HttpLayer } from '../http.js';
import type { DocsSearchResponse, DocsReadResponse } from '../types/docs-corpus.js';

export class DocsCorpusResource {
  constructor(private http: HttpLayer) {}

  /**
   * Search the global docs corpus (dense + lexical fusion). Not tenant-filtered
   * — the corpus is system-wide. Fails loud server-side if the corpus was never
   * indexed (a missing index is never returned as "no results").
   */
  async search(query: string, limit?: number): Promise<DocsSearchResponse> {
    return this.http.post('/v1/docs/search', { query, limit });
  }

  /** Read one SDK method's stored docs detail. */
  async read(resource: string, method: string): Promise<DocsReadResponse> {
    return this.http.get(
      `/v1/docs/${encodeURIComponent(resource)}/${encodeURIComponent(method)}`,
    );
  }
}
